import { makeUseAxios } from 'axios-hooks';
import axios from 'axios';
import { env } from 'Shared/constants/env';
import { makeApiHooks } from './makeHooks';

const axiosInstance = axios.create({
  baseURL: `${env.reznorHostname}/api/v2`,
});

const useAxios = makeUseAxios({
  axios: axiosInstance,
});

export const { useLazyApi: useLazyV2Api, useNewApi: useV2Api } =
  makeApiHooks(useAxios);
